// GraficoEstadosPlugin.js
import DescargaDatos from "./DescargaDatos.vue";
import DescargaDatosProperties from "./DescargaDatosProperties.vue";

const DescargaDatosPlugin = {
  install(Vue) {
    Vue.component("DescargaDatos", DescargaDatos);
    Vue.component("DescargaDatosProperties", DescargaDatosProperties);
  },
};

export default DescargaDatosPlugin;
